import { render } from "./ProjectAdDocumentView.vue?vue&type=template&id=cf2e0be4&ts=true"
import script from "./ProjectAdDocumentView.vue?vue&type=script&lang=ts"
export * from "./ProjectAdDocumentView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__